import $ from 'jquery';
import SearchResults from './search/results';

export default function publications() {
  const searchResults = new SearchResults();
  let selectedProducts = [];

  // ajax request
  const ajax = (product) => {
    $('.js-search-results').addClass('is-loading');

    const request = $.ajax({
      type: 'POST',
      url: '/search/endpoint.php',
      data: {
        'query': '',
        'config': {
          'where': {
            'products': product,
            'es_doc_type': 'publication',
          },
          'sort': {'published_date': 'desc'},
        }
      },
      timeout: 10000,
      dataType: 'json',
    });

    request.done((response) => {
      const data = response.hasOwnProperty('data') ? response.data : [];
      const tabsBtn = $(`.js-tabs-btn[data-tab=${product}]`);

      tabsBtn.removeClass('is-hidden');

      if ( !tabsBtn.hasClass('is-loaded') ) {
        tabsBtn.addClass('is-loaded').find('.js-number').text(`(${data.length})`);
        createTabsContent(product, data);
      }

      tabsBtn.trigger('click');
    });

    request.always(() => {
      $('.js-search-results').removeClass('is-loading');
    });

    request.fail(() => {
      console.log('fail');
    });
  };

  // html content with search results
  const createTabsContent = (product, data) => {
    const entries = data.map((doc) => searchResults.entry(doc, true)).join('');

    $('.js-search-results-entries').append(`
      <div class="tabs__content js-tabs-content" data-tab="${product}">
        ${!data.length ? '<h2>No results</h2>' : entries}
      </div>
    `);
  };

  const reset = () => {
    selectedProducts = [];

    $('.js-tabs-btn').addClass('is-hidden');
    $('.js-tabs-content').removeClass('is-active');
    $('.js-main-content-subtitle').show();
  };

  // product checkboxes
  $('.js-product-list .js-filter-control').on('change', function () {
    const product = $(this).val();

    // max 3 selected items
    if ( $('.js-product-list .js-filter-control:checked').length > 3 ) {
      $(this).prop('checked', false);

      return;
    }

    if ( $(this).is(':checked') ) {
      selectedProducts.push(product);

      ajax(product);
    } else {
      selectedProducts = selectedProducts.filter(selectedProduct => selectedProduct !== product);

      $(`.js-tabs-btn[data-tab="${product}"]`).addClass('is-hidden');
      $(`.js-tabs-content[data-tab="${product}"]`).removeClass('is-active');

      if ( $('.js-tabs-btn:visible').length ) {
        $('.js-tabs-btn:visible').first().trigger('click');
      }
    }

    if (selectedProducts.length) {
      $('.js-main-content-subtitle').hide();
    } else {
      $('.js-main-content-subtitle').show();
    }
  });

  // reset button
  $('.js-filter-reset-btn').on('click', function () {
    reset();
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/project/publications.js